import isEmpty from "lodash/isEmpty";
import Router from "next/router";
import { ParsedUrlQueryInput } from "node:querystring";
import qs from "query-string";

/**
 * Remove an argument from the current URL without refreshing the page. This
 * function replaces the current URL with the new one without adding it to the
 * navigation history.
 *
 * Examples:
 * single arg    - removeArgFromUrl('hi')
 * multiple args - removeArgFromUrl('hi', 'two')
 */
export const removeArgFromUrl = (...args: string[]) => {
  const query = qs.parse(window.location.search) as ParsedUrlQueryInput;

  for (const arg of args) {
    delete query[arg];
  }

  const queryString = !isEmpty(query) ? `?${qs.stringify(query)}` : "";
  const url = `${window.location.pathname}${queryString}`;

  Router.replace({ pathname: Router.pathname, query }, url, { shallow: true });
};

export const addArgToUrl = (newQuery: {
  [key: string]: string | number | string[];
}) => {
  const query = {
    ...qs.parse(window.location.search),
    ...newQuery,
  } as ParsedUrlQueryInput;

  const queryString = `?${qs.stringify(query)}`;
  const url = `${window.location.pathname}${queryString}`;

  Router.replace({ pathname: Router.pathname, query }, url, { shallow: true });
};
